import {Typography} from '@bonprix/design-system';
import {SearchResultItemLegacy} from './SearchResultItemLegacy.jsx';
import React from 'react';
import useSearchTexts from '../hooks/use-search-texts.js';

export const SearchDropdownLegacy = ({
    listMode,
    currentList,
    deferredSearchTerm,
    selectedIndex,
    selectionMode,
    handleSelectItem,
    handleSearchResultItemHover,
    unselectField,
    clearSearchHistory,
}) => {
    const {data: searchTextsData} = useSearchTexts();
    const HISTORY_LIST_MODE = 'HISTORY';

    return (
        <div
            className="search-legacy__input-dropdown xl:border-solid xl:border xl:border-clr-on-primary-mid"
            onMouseLeave={unselectField}
            onMouseDown={(e) => {
                e.preventDefault();
            }}
        >
            {listMode === HISTORY_LIST_MODE && (
                <div className="search-legacy__input__dropdown-header">
                    <Typography variant="bonprix-h5" component={'span'}>
                        {searchTextsData?.searchHistoryHeader}
                    </Typography>
                    <button className={'search-legacy__input__dropdown__clear__history-button'} onClick={clearSearchHistory}>
                        {searchTextsData?.clearSearchHistory}
                    </button>
                </div>
            )}
            <ul
                className={'search-legacy__input__dropdown-list'}
                role="listbox"
                id="search-suggestions-listbox"
                aria-label={searchTextsData?.searchHistoryHeader}
            >
                {currentList.map((item, index) => (
                    <SearchResultItemLegacy
                        key={index}
                        searchTerm={deferredSearchTerm}
                        value={item}
                        listMode={listMode}
                        isActive={index === selectedIndex}
                        selectionMode={selectionMode}
                        onSelect={handleSelectItem}
                        id={`search-option-${index}`}
                        onMouseOver={() => {
                            handleSearchResultItemHover(index);
                        }}
                    />
                ))}
            </ul>
        </div>
    );
};
